// extracted by mini-css-extract-plugin
export var container = "PosImport-module--container--A9iFZ";
export var content = "PosImport-module--content--YNfnl";
export var label = "PosImport-module--label--7wklQ";
export var subHeader = "PosImport-module--subHeader--Ea7Ey";
export var title = "PosImport-module--title--ocrSp";